import { faCirclePlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import styles from './create-box.module.scss';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { useViewSelector } from 'src/components/common/view-selector';
import { Tooltip } from 'src/components/core';

export function CreateBox({ adminMode, onClick, disabled = false, disabledTooltip = null }) {
  const lang = useSelector(getLang('ACTION_BUTTON_TOOLTIPS'));
  const { isGridView } = useViewSelector();

  if (!adminMode) return null;

  // `aria-disabled` rather than the `disabled` attribute keeps the control focusable,
  // so the tooltip explaining why it's blocked stays reachable by keyboard.
  const box = (
    <button
      data-key="create-content-box"
      className={classNames(isGridView ? styles.createBox : styles.createRow, {
        [styles.disabled]: disabled,
      })}
      onClick={disabled ? undefined : onClick}
      aria-disabled={disabled}
      aria-label={lang.ADD_DIRECTORY}>
      <FontAwesomeIcon icon={faCirclePlus} className={styles.icon} />
      <p>{lang.ADD_DIRECTORY}</p>
    </button>
  );

  if (disabled && disabledTooltip) {
    return (
      <Tooltip title={disabledTooltip} placement="topLeft" arrow={{ pointAtCenter: false }}>
        {box}
      </Tooltip>
    );
  }

  return box;
}
